// This will be renamed to .ts when GeoFenceIcon is replaced with tool icon map value

import React, { type ReactNode } from 'react';
import DiamondEmpty from '@uber/base-icons/diamond-empty';
import type { HeaderInfoT, LabelMappedAnnotationT } from '../annotations/types';
import type { ModernizedGenericAnnotation, ToolConfigMap } from '../types';
import { isAnnotationImported } from '../utils/is-annotation-imported';
export const getAnnotationItemKey = (annotationId: string) => `annotation-${annotationId}`;
export const getHeaderItemKey = (label: string) => `header-${label}`;
export const getLabelMappedAnnotations = (annotations: ModernizedGenericAnnotation[], importedAnnotationIds: string[]): LabelMappedAnnotationT => annotations.reduce<LabelMappedAnnotationT>((acc, annotation) => {
  const isPending = (annotation.annotationLabel.questionnaire?.length ?? 0) > 0 && Object.keys(annotation.metadata?.answers ?? {}).length === 0;
  const label = annotation.annotationLabel.title;
  const labelDetails = acc[label] ?? {
    headerInfo: {
      annotationCount: 0,
      isVisible: true,
      iconConfig: {
        color: annotation.annotationLabel.style.strokeColor,
        iconKey: annotation.annotationLabel.tools?.length === 1 ? annotation.annotationLabel.tools[0] ?? '' : ''
      }
    },
    annotations: []
  };
  acc[label] = labelDetails;
  labelDetails.annotations.push({
    name: `${label}\u00A0\u00A0[${annotation.id}]`,
    // \u00A0 is a non-breaking space
    id: annotation.id,
    isVisible: !annotation.hidden,
    isLocked: annotation.locked ?? false,
    isSelected: false,
    // this will change when we consume selected annotation from the store
    attributes: annotation.tags ?? [],
    isPending,
    isDisabled: isAnnotationImported(annotation, importedAnnotationIds),
    canCopyObjectInstance: annotation.canCopyObjectInstance ?? false,
    annotationType: annotation.annotationType
  });
  labelDetails.headerInfo.annotationCount++;
  // Set label visibility based on whether all annotations in this label are visible
  labelDetails.headerInfo.isVisible = labelDetails.annotations.some(ann => ann.isVisible);
  return acc;
}, {});
export const getLabelIcon = (iconConfig: HeaderInfoT['iconConfig'], toolConfig: ToolConfigMap, iconSize?: number): ReactNode => {
  if (iconConfig?.iconKey) {
    const IconComponent = toolConfig[iconConfig.iconKey]?.Icon;
    if (IconComponent) {
      return <IconComponent strokeColor={iconConfig.color} />;
    }
  }
  return <DiamondEmpty size={iconSize ?? 16} color={iconConfig?.color} />;
};